<template>
  <a-modal
    :title="'系统初始化'"
    :width="1200"
    :visible="visible"
    :footer="null"
    @cancel="visible = false"
    class="custom-modal"
  >
    <div class="sys-container">
      <div
        class="sys-card"
        v-for="(item, index) in dataSys"
        :key="index"
        @click.prevent="routeEvent(item.url)"
        :class="{
          'success-card': sysInfo[item.field],
          'error-card': !sysInfo[item.field],
        }"
      >
        <a-result :status="sysInfo[item.field] ? 'success' : 'error'" :title="item.title" class="result-card">
          <template #icon>
            <div class="status-icon">
              <check-circle-outlined v-if="sysInfo[item.field]" class="success-icon" />
              <close-circle-outlined v-else class="error-icon" />
            </div>
          </template>
          <template #extra>
            <div class="status-text">
              {{ sysInfo[item.field] ? '已完成' : '未完成' }}
            </div>
          </template>
        </a-result>
      </div>
    </div>
  </a-modal>
</template>

<script>
// import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'

const dataSys = [
  { title: '门店配置', field: 'storeInitStatus', url: '/shop/index' },
  { title: '员工列表', field: 'empInitStatus', url: '/user/user/index' },
  { title: '增加商品', field: 'goodsInitStatus', url: '/goods/name/index' },
  { title: '供应商&经销商', field: 'supplierInitStatus', url: '/agent/index' },
  { title: '收款账户', field: 'accountInitStatus', url: '/cashier/account/index' },
  { title: '支付方式', field: 'paymentMethodInitStatus', url: '/system/paytype' },
  { title: '运营商业务配置', field: 'opBusinessinitStatus', url: '/mobile/mobile/index' },
  { title: '售后业务配置', field: 'svBusinessInitStatus', url: '/service/goods' },
]

export default {
  // components: {
  //   CheckCircleOutlined,
  //   CloseCircleOutlined,
  // },
  props: {
    sysInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataSys,
      visible: false,
    }
  },
  methods: {
    routeEvent(url) {
      this.$router.push({ path: url })
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
@primary-color: #1890ff;
@success-color: #52c41a;
@error-color: #ff4d4f;
@card-hover: #f0f7ff;
@border-radius: 8px;

.custom-modal {
  :deep(.ant-modal-body) {
    padding: 24px;
    background: #f8fafc;
  }
}

.sys-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  padding: 8px;
}

.sys-card {
  cursor: pointer;
  border-radius: @border-radius;
  transition: all 0.3s cubic-bezier(0.34, 0.69, 0.1, 1);
  padding: 16px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    width: 100%;
    border-radius: @border-radius @border-radius 0 0;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
}

.success-card {
  background: #fff;
  border: 1px solid #e8f4ff;

  &::before {
    background: @success-color;
  }

  &:hover {
    background: @card-hover;
    border-color: @primary-color;
  }
}

.error-card {
  background: #fff;
  border: 1px solid #ffeaea;

  &::before {
    background: @error-color;
  }

  &:hover {
    background: #fff9f9;
    border-color: @error-color;
  }
}

.result-card {
  padding: 0;

  :deep(.ant-result-icon) {
    margin-bottom: 8px;

    .anticon {
      font-size: 24px;
    }
  }

  :deep(.ant-result-title) {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }
}

.status-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  .success-icon {
    color: @success-color;
    font-size: 32px;
  }

  .error-icon {
    color: @error-color;
    font-size: 32px;
  }
}

.status-text {
  margin-top: 8px;
  font-size: 13px;
  font-weight: 500;

  .success-card & {
    color: @success-color;
  }

  .error-card & {
    color: @error-color;
  }
}
</style>
